export const BoltIcon = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M13.5 2L4 13h6l-1.5 9L20 10h-6l1.5-8z" />
  </svg>
)